import DropZone from './drop-zone';

export default DropZone;